import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { COMPLETE_ROUTE_ACCESS } from './routes.config';
import MainLayout from '../layout/MainLayout';
import { SatelliteDataProvider } from '../context/SatelliteDataContext';

const ProtectedRoute = ({ children }) => {
  const { user, selectedRole } = useAuth();
  const location = useLocation();

  // Verificar si el usuario está autenticado
  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Verificar si hay un rol seleccionado
  if (!selectedRole) {
    return <Navigate to="/dashboard" replace />;
  }

  // Verificar acceso para rutas exactas o dinámicas
  const hasAccess = Object.entries(COMPLETE_ROUTE_ACCESS).some(([route, roles]) => {
    const dynamicRouteRegex = new RegExp(
      `^${route.replace(/:[^\s/]+/g, '[^/]+')}$`
    );
    const matches = dynamicRouteRegex.test(location.pathname);

    if (matches) {
      // Validar contra role_code (primario) O name (secundario) del selectedRole actual
      const roleMatches = roles.includes(selectedRole.role_code) || 
                         roles.includes(selectedRole.name);
      if (roleMatches) {
        return true;
      }
    }

    return false;
  });

  if (!hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  // El calculador de transporte ya tiene DocumentProvider y DocumentLayout 
  // dentro de TransportCalculatorContainer, solo devolvemos children
  if (location.pathname.startsWith('/transport-calculator')) {
    return children;
  }

  // Para el resto de rutas protegidas, usar el MainLayout normal
  return (
    <SatelliteDataProvider>
      <MainLayout>{children}</MainLayout>
    </SatelliteDataProvider>
  );
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;